import { ReactElement } from 'react'
import Layout from '../../../components/layout'
import ShopProductDetails from '../../../components/Shops/Products/details'


const ShopProductDetailsPage = (): ReactElement => {
  return (
    <Layout >
      <ShopProductDetails />
    </Layout>
  )
}

export default ShopProductDetailsPage
